import React from "react";

const FileChip = ({ file }) => {
  const name = file?.fileName || file?.name;
  if (!name) return null;

  return (
    <div className="inline-flex items-center gap-3 max-w-full bg-light rounded-md py-2 px-4">
      <i className="fa-regular fa-file text-lg text-red-500 shrink-0"></i>
      <p className="text-sm truncate">{name}</p>
      {file.url && (
        <a href={file.url} target="_blank" rel="noopener noreferrer" className="shrink-0">
          <i className="fa-solid fa-download text-emerald-700 text-sm"></i>
        </a>
      )}
    </div>
  );
};

export default FileChip;
